<template>
  <v-main class="bg-transparent">
    <v-container id="document-content" class="pb-8 px-6" fluid>
      <v-slide-y-transition mode="out-in">
        <v-card
          class="content-list bg-transparent relative"
          :ref="'ref-top'"
          elevation="0"
          v-cloak
        >
          <!-- 1、2 -->
          <v-card-title class="font-weight-black">
            <v-icon left>mdi-file-document</v-icon>
            {{ title }}
            <v-spacer></v-spacer>
            <div class="w-300-px">
              <v-text-field
                dense
                label="Search"
                outlined
                hide-details
                append-icon="mdi-magnify"
                :value="searchInputData"
                @input="
                  (e) => {
                    e = e.replace(/\s*/g, '')
                    searchInputData = e
                  }
                "
                @click:append="search()"
                @keydown.enter="search()"
              ></v-text-field>
            </div>
          </v-card-title>
          <v-divider class="mb-30-px"></v-divider>

          <v-card-text class="py-0">
            <!-- content -->
            <component
              v-if="countents.container.topic && searchResult.length === 0"
              :is="pageName"
              ref="component"
              :contenList="countents"
              :beAbleEdit="true"
              :editedAuth="editedAuth"
            ></component>

            <!-- search result -->
            <template v-for="(item, index) in searchResult">
              <div :key="index">
                <h2 v-html="markSearchData('topic', item.node)"></h2>
                <div
                  v-for="(leaf, leaf_i) in item.leaves"
                  :key="leaf_i"
                  v-html="markSearchData('content', item.node, leaf)"
                  class="px-20-px py-10-px"
                ></div>
                <v-divider class="my-10-px"></v-divider>
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-container>
  </v-main>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ContentList from '@/components/elements/block/ContentList.vue'
import BriefList from '@/components/elements/block/BriefList.vue'

export default {
  name: 'DocumentContent',

  provide() {
    return {
      scrollMeTo: this.scrollMeTo
    }
  },

  components: { ContentList, BriefList },

  props: ['editedAuth'],

  data() {
    return {
      searchInputData: '',
      searchData: '',
      searchResult: []
    }
  },

  computed: {
    ...mapState('common', ['modifyMode', 'lang']),
    ...mapState('document', [
      'countentsFromDB',
      'currMenuObj',
      'showRemoveData',
      'allChapterList'
    ]),
    countents() {
      const data = JSON.parse(JSON.stringify(this.countentsFromDB))

      if (!this.modifyMode.show || !this.showRemoveData) {
        data.node = data.node.filter((item) => {
          return item.flag === 1
        })
        data.leaf = data.leaf.filter((item) => {
          return item.flag === 1
        })
      }

      const node = data.node.map((item) => {
        item.refKey = this.mapRef(item)
        item.active = false
        return item
      })

      const menus = node.filter((item) => item.level < 3)

      const chapters = node.filter((item) => item.level > 2)

      const titles = chapters.length === 0 ? [] : chapters

      const contents = JSON.parse(JSON.stringify(data.leaf))
        .map((item) => {
          item.format = item.format[0].toUpperCase() + item.format.slice(1)
          switch (item.format) {
            case 'Table':
              item.content = JSON.parse(JSON.stringify(item.content))
              break
          }
          return item
        })
        .sort((a, b) => {
          return a.parentId > b.parentId ? 1 : -1
        })

      const obj = {
        menus: menus,
        container: {},
        children: {}
      }

      if (this.currMenuObj) {
        obj.container = this.currMenuObj
        obj.container.list = contents
          .filter(function (item) {
            return item.parentId === obj.container.menuId
          })
          .sort(function (a, b) {
            return a.sn > b.sn ? 1 : -1
          })

        for (const i in titles) {
          const curr = titles[i]
          curr.list = contents
            .filter(function (item) {
              return item.parentId === curr.menuId
            })
            .sort(function (a, b) {
              return a.sn > b.sn ? 1 : -1
            })

          switch (curr.level) {
            case 3:
              obj.children[curr.menuId] = curr
              obj.children[curr.menuId].children = {}
              break
            case 4:
              if (obj.children[curr.parentId]) {
                obj.children[curr.parentId].children[
                  curr.sn + '_' + curr.menuId
                ] = curr
              }
              break
          }
        }
        obj.children = Object.values(obj.children).sort(function (a, b) {
          return a.sn > b.sn ? 1 : -1
        })
        for (const i in obj.children) {
          const curr = obj.children[i]
          curr.children = Object.values(curr.children).sort(function (a, b) {
            return a.sn > b.sn ? 1 : -1
          })
        }
      }

      return obj
    },
    title() {
      let title = this.countents.container[this.topicKey]

      if (this.searchResult.length > 0) {
        title = 'Your search results'
      }
      if (!title) {
        title =
          this.countents.container[`topic${this.lang === 'en' ? 'En' : ''}`]
      }
      if (!title) {
        title = this.countents.container.topic
      }
      return title
    },
    pageName() {
      return this.currMenuObj.menuId === 1 ? 'BriefList' : 'ContentList'
    }
  },

  watch: {
    lang() {
      if (this.searchData !== '') {
        this.search()
      }
    },
    searchInputData(newVal) {
      if (!newVal) {
        this.searchData = newVal
        this.searchResult = []
      }
    },
    currMenuObj: {
      handler: function () {
        this.searchResult = []
        this.searchData = ''
        this.searchInputData = ''
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('message', ['setSnackbar']),
    mapRef(item) {
      const ref = 'leaf_' + item.level + '_' + item.parentId + '_' + item.menuId
      return ref
    },
    markSearchData(key, menu, content) {
      const obj = key === 'topic' ? menu : content
      let text = obj[key]
      if (key === 'topic' && this.lang === 'en' && obj[key + 'En']) {
        text = obj[key + 'En'] ? obj[key + 'En'] : text
      }

      const stripHTML = (input) => {
        let output = ''
        if (typeof input === 'string') {
          output = input.replace(/(<([^>]+)>)/gi, '')
          output = output.replace(/(\n)/gi, '')
          output = output.replace(/(\\n)/gi, '')
        }
        return output
      }

      text = stripHTML(text)

      const limitLength = 100
      let newText = ''
      if (text.length > limitLength) {
        const newTextArr = text.split(this.searchData)
        const allowLimitLength = limitLength - this.searchData.length

        for (let i = 0; i < newTextArr.length - 1; i++) {
          let lastLength = allowLimitLength
          let strStart = newTextArr[i]
          let strEnd = newTextArr[i + 1]

          const lastLengthhalf = lastLength / 2
          if (strStart.length > lastLengthhalf) {
            const startIndex = strStart.length - lastLengthhalf
            strStart = strStart.slice(startIndex)
            strStart = '...' + strStart
          }
          lastLength -= strStart.length

          if (strEnd.length > lastLength) {
            strEnd = strEnd.slice(0, lastLength)
            strEnd += '...'
          }
          newText += `<div class="my-8-px">${strStart}${this.searchData}${strEnd}</div>`
        }
      } else {
        newText = text
      }

      const regexp = new RegExp(this.searchData, 'g')

      const mapHref = () => {
        let href = '/document?menuId='
        if (menu.level > 2) {
          let leftMenuObj = this.allChapterList.find(
            (item) => item.menuId === menu.parentId
          )
          if (leftMenuObj.level > 2) {
            leftMenuObj = this.allChapterList.find(
              (item) => item.menuId === leftMenuObj.parentId
            )
          }

          href += `${leftMenuObj.menuId}&ref=${this.mapRef(menu)}`
        } else {
          href += menu.menuId
        }
        return href
      }

      return newText.replace(
        regexp,
        `<a class="d-inline-block px-10-px py-2-px orange lighten-2 rounded" target="_blank" href="${mapHref()}">${
          this.searchData
        }</a>`
      )
    },
    scrollMeTo(ref) {
      let el
      if (this.$refs[ref]) {
        el = Array.isArray(this.$refs[ref])
          ? this.$refs[ref][0].$el
          : this.$refs[ref].$el
      } else if (this.$refs.component.$refs[ref]) {
        el = Array.isArray(this.$refs.component.$refs[ref])
          ? this.$refs.component.$refs[ref][0].$el
          : this.$refs.component.$refs[ref].$el
      } else {
        return
      }

      this.$nextTick(() => {
        this.$scrollTo(el)
      })
    },
    search() {
      const minLength = 1
      if (this.searchInputData.length <= minLength) {
        this.setSnackbar({
          show: true,
          text: `The keyword count must be greater than ${minLength}.`,
          type: 'text'
        })
        return
      }
      this.searchData = this.searchInputData
      const data = {
        keyword: this.searchData
      }
      this.$api.common.leaf.search(data).then((e) => {
        const res = e.results
        if (res.length === 0) {
          this.setSnackbar({
            show: true,
            text: 'Sorry, no matching data.',
            type: 'text'
          })
        } else {
          this.searchResult = res
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-list {
  overflow: hidden;
  background-color: rgb(240, 240, 240) !important;
  min-height: 90vh;
  padding: 10px 32px !important;
}
</style>
